/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type ServiceTypeEnum = 'VCDR' | 'VMCFS';

export const ServiceTypeEnum = {

    VCDR: 'VCDR' as ServiceTypeEnum,

    VMCFS: 'VMCFS' as ServiceTypeEnum
};

